import React from 'react';
import { Alert } from 'antd';
import { useConnectionStatus } from '../../services/connectionStatus';
import { isOfflineCajaDevice } from '../../utils/serviceWorker';

/**
 * Aviso fijo mientras el dispositivo no llega al servidor.
 *
 * Antes la única señal era un botón girando: la cajera no sabía si el cobro estaba
 * "pensando" o si se había caído el internet, y repetía la acción o cerraba sesión
 * (la sesión zombi). Se quita solo cuando vuelve a haber respuesta (ver connectionStatus).
 */
const ConnectionBanner: React.FC = () => {
  const status = useConnectionStatus();
  if (status === 'online') return null;

  // En la caja offline las mesas y la carta salen de la copia guardada (offlineCache):
  // hay que decir que pueden no estar al día, o se tomarían por vigentes.
  const description = isOfflineCajaDevice()
    ? 'Se muestran la carta y las mesas guardadas en este equipo; pueden no estar al día. Revisa el internet del restaurante.'
    : 'Revisa el internet del restaurante. Lo que no se guardó se puede volver a intentar sin que se duplique.';

  return (
    <Alert
      type="warning"
      showIcon
      banner
      style={{ marginBottom: 12 }}
      message="Sin conexión con el servidor"
      description={description}
    />
  );
};

export default ConnectionBanner;
